import { render, staticRenderFns } from "./Nosotros.vue?vue&type=template&id=1501b224&scoped=true"
import script from "./Nosotros.vue?vue&type=script&lang=js"
export * from "./Nosotros.vue?vue&type=script&lang=js"
import style0 from "./Nosotros.vue?vue&type=style&index=0&id=1501b224&prod&lang=scss"
import style1 from "./Nosotros.vue?vue&type=style&index=1&id=1501b224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1501b224",
  null
  
)

export default component.exports